import React from 'react';
import { Row, Col, Table, Button } from 'reactstrap';

const Statistics = ({ adminInfo, onBtnGetAdminInfoClick }) => {
  const allTimeInfoForAdminDto = adminInfo.allTimeInfoForAdminDto;
  const lastWeekInfoForAdminDto = adminInfo.lastWeekInfoForAdminDto;
  const yesterdayInfoForAdminDto = adminInfo.yesterdayInfoForAdminDto;

  return (
    <div>
      <Row>
        <Col>
          <div className="content-heading">
            <div>
              Processes
              <small>Info about all processes regarding Tenants (such as mail informing etc)</small>
            </div>
          </div>
        </Col>
        <Col></Col>
      </Row>
      <Row>
        <Col>
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <Table striped bordered style={{ minWidth: '800px' }}>
              <thead>
                <tr>
                  <th style={{ width: '10%' }}>Command name</th>
                  <th style={{ width: '90%' }}>Data</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <Button
                      id="btnGetInfoForTenant"
                      color="primary"
                      style={{ float: 'left' }}
                      onClick={() => onBtnGetAdminInfoClick()}
                    >
                      <b>Get Info</b>
                    </Button>
                  </td>
                  <td>
                    <Row>
                      <Col>
                        <div>
                          <h2>All time:</h2>
                          <p>Num Tenants: {allTimeInfoForAdminDto.numTenants}</p>
                          <p>Num Users: {allTimeInfoForAdminDto.numUsers}</p>
                          <p>Num Jobs: {allTimeInfoForAdminDto.numJobs}</p>
                          <p>Num Applicants: {allTimeInfoForAdminDto.numApplicants}</p>
                          <p>Num Applications: {allTimeInfoForAdminDto.numApplications}</p>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2>Yesterday:</h2>
                          <p>Num Tenants: {yesterdayInfoForAdminDto.numTenants}</p>
                          <p>Num Users: {yesterdayInfoForAdminDto.numUsers}</p>
                          <p>Num Jobs: {yesterdayInfoForAdminDto.numJobs}</p>
                          <p>Num Applicants: {yesterdayInfoForAdminDto.numApplicants}</p>
                          <p>Num Applications: {yesterdayInfoForAdminDto.numApplications}</p>
                        </div>
                      </Col>
                      <Col>
                        <div>
                          <h2>Last 7 days:</h2>
                          <p>Num Tenants: {lastWeekInfoForAdminDto.numTenants}</p>
                          <p>Num Users: {lastWeekInfoForAdminDto.numUsers}</p>
                          <p>Num Jobs: {lastWeekInfoForAdminDto.numJobs}</p>
                          <p>Num Applicants: {lastWeekInfoForAdminDto.numApplicants}</p>
                          <p>Num Applications: {lastWeekInfoForAdminDto.numApplications}</p>
                        </div>
                      </Col>
                    </Row>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Statistics;
